// Project
import request from "../request";

/**
 * Create a new prompt.
 *
 * @param {Object} params
 * @param {string} params.name
 * @param {string} params.prompt
 * @returns {Promise<string[]>}
 */
export const createPrompt = async (params) => {
	const { name, prompt, isJiraPrompt } = params;

	const response = await request({
		url: "ai/prompts",
		method: "POST",
		data: {
			name,
			prompt,
			isJiraPrompt,
		},
	});

	return response.data;
};

/**
 * Get all prompts.
 */
export const getPrompts = async () => {
	const response = await request({
		url: "ai/prompts",
		method: "GET",
	});

	return response.data;
};

/**
 * Get prompt by ID.
 * @param {string} promptId
 */
export const getPrompt = async (promptId, version) => {
	const response = await request({
		url: `ai/prompts/${promptId}/${version}`,
		method: "GET",
	});

	return response.data;
};

/**
 * Update a prompt by ID.
 * @param {string} id
 * @param {Object} update
 * @param {string} [update.name]
 * @param {string} [update.prompt]
 */
export const updatePrompt = async (id, update) => {
	const response = await request({
		url: `ai/prompts/${id}`,
		method: "PUT",
		data: update,
	});

	return response.data;
};

/**
 * Delete a prompt by ID.
 * @param {string} id
 */
export const deletePrompt = async (id) => {
	const response = await request({
		url: `ai/prompts/${id}`,
		method: "DELETE",
	});

	return response.data;
};

export const getModels = async () => {
	const response = await request({
		url: "ai/models",
		method: "GET",
	});

	return response.data;
};

/**
 * Get all knowledge projects.
 */
export const getKnowledgeProjects = async () => {
	const response = await request({
		url: "ai/knowledge-projects",
		method: "GET",
	});

	return response.data.map((project) => {
		return {
			_id: project._id,
			name: project.name,
			createdBy: project.created_by,
			createdAt: new Date(project.created_at),
			updatedAt: new Date(project.updated_at),
		};
	});
};

/**
 *
 * @param {Object} params
 * @param {string} params.name
 */
export const createKnowledgeProject = async (params) => {
	const response = await request({
		url: "ai/rag",
		method: "POST",
		data: params,
	});

	return response.data;
};

export const uploadKnowledgeFiles = async (projectId, files) => {
	const formData = new FormData();

	for (const file of files) {
		formData.append("files", file);
	}

	const response = await request({
		url: `ai/knowledge-projects/${projectId}/files`,
		method: "POST",
		data: formData,
		headers: {
			"Content-Type": "multipart/form-data",
		},
	});

	return response.data;
};

export const getKnowledgeProject = async (projectId) => {
	const response = await request({
		url: `ai/knowledge-projects/${projectId}`,
		method: "GET",
	});

	return response.data;
};

export const getKnowledgeProjectFiles = async (projectId) => {
	const response = await request({
		url: `ai/knowledge-projects/${projectId}/files`,
		method: "GET",
	});

	return response.data;
};

export const deleteKnowledgeProjectFile = async (projectId, fileName) => {
	const response = await request({
		url: `ai/knowledge-projects/${projectId}/files/${fileName}`,
		method: "DELETE",
	});

	return response.data;
};

export const updateKnowledgeProject = async (projectId, update) => {
	const response = await request({
		url: `ai/knowledge-projects/${projectId}`,
		method: "PUT",
		data: update,
	});

	return response.data;
};

export const deleteKnowledgeProject = async (projectId) => {
	const response = await request({
		url: `ai/knowledge-projects/${projectId}`,
		method: "DELETE",
	});

	return response.data;
};
